import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Table, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import Moment from 'moment';
import Dialog from 'react-bootstrap-dialog';
import './TextLibrarySnippetTextLibrariesTable.css';
import TooltipButton from './TooltipButton';

Moment.locale('en');

class TextLibrarySnippetTextLibrariesTable extends Component {
    constructor(props) {
        super(props);
    }

    didConfirmDelete(textlibrary) {
        this.props.onDelete(textlibrary);
    }

    didSaveChanges(textlibrary, newName) {
        this.props.onSave(textlibrary, newName);
    }

    onBeforeDragStart = () => {
        this.setState({
            isDragging: true
        });
    };

    onDragEnd = result => {
        this.setState({
            isDragging: false
        });

        // dropped outside the list
        if (
            !result.destination ||
            result.destination.index === result.source.index
        ) {
            return;
        }

        // no movement
        if (result.destination.index === result.source.index) {
            return;
        }

        this.props.onDragEnd(result);
    };

    handleEditClicked(textlibrary) {
        const { t } = this.props;

        this.dialog.show({
            body: t('OrganisationTextLibrariesTable.textlibrary_name'),
            prompt: Dialog.TextPrompt({
                placeholder: t('OrganisationTextLibrariesTable.name'),
                initialValue: textlibrary.name
            }),
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => console.log('Cancel!'),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.save'),
                    dialog => this.didSaveChanges(textlibrary, dialog.value),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => {
                dialog.hide();
            }
        });
    }

    handleDeleteClicked(textlibrary) {
        const { t } = this.props;

        this.dialog.show({
            title: t('Dialog.warning'),
            body: t('Dialog.sure_deletion'),
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => console.log('Cancel!'),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.delete'),
                    () => this.didConfirmDelete(textlibrary),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => {
                dialog.hide();
            }
        });
    }

    componentDidMount() {}

    render() {
        const {
            t,
            uuid,
            pageUUID,
            playerUUID,
            textlibraries,
            snippet
        } = this.props;

        const getItemStyle = (isDragging, draggableStyle) => ({
            // some basic styles to make the items look a bit nicer
            userSelect: 'none',
            background: isDragging ? '#dddddd' : '',
            display: isDragging ? 'table' : '',
            ...draggableStyle
        });

        const getListStyle = isDraggingOver => ({
            borderCollapse: isDraggingOver ? 'separate' : 'collapse'
        });

        let textlibraryRows = textlibraries.map((textlibrary, index) => {
            let iconName = 'fas fa-font';

            let textlibraryLink = `/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/textlibrarysnippets/${
                snippet.uuid
            }/textlibraries/${textlibrary.uuid}?rel=player`;
            if (this.props.rel === 'snippet') {
                textlibraryLink = `/organisations/${uuid}/textlibrarysnippets/${
                    snippet.uuid
                }/textlibraries/${textlibrary.uuid}?rel=snippet`;
            } else if (this.props.rel === 'page') {
                textlibraryLink = `/organisations/${uuid}/pages/${pageUUID}/textlibrarysnippets/${
                    snippet.uuid
                }/textlibraries/${textlibrary.uuid}?rel=page`;
            }

            console.log(`textlibrary: ${JSON.stringify(textlibrary)}`);
            return (
                <Draggable
                    key={`${index}.${textlibrary.uuid}`}
                    draggableId={`${index}.${textlibrary.uuid}`}
                    index={index}
                >
                    {(provided, snapshot) => (
                        <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                            )}
                        >
                            <td width="10">
                                <i
                                    className="fa fa-bars"
                                    aria-hidden="true"
                                    style={{ color: '#d0d0d0' }}
                                />
                            </td>
                            <td width="500">
                                {textlibrary.global ? (
                                    <span className="label label-success">
                                        <i className={'fa fa-globe'} />{' '}
                                        {t(
                                            'TextLibrarySnippetTextLibrariesTable.global'
                                        )}
                                    </span>
                                ) : null}{' '}
                                <Link
                                  style={{
                                     alignItems: "center",
                                     textAlign: "left"
                                   }}
                                  className="label label-primary"
                                   to={textlibraryLink}>
                                    <i className={`${iconName}`} />{' '}
                                    {textlibrary.name}
                                </Link>
                            </td>
                            <td className="hidden-xs">
                                {Moment(textlibrary.updatedAt).format(
                                    'YYYY-MM-DD HH:mm'
                                )}
                            </td>
                            <td className="hidden-xs">
                                {Moment(textlibrary.createdAt).format(
                                    'YYYY-MM-DD HH:mm'
                                )}
                            </td>
                            <td align="center">
                                <TooltipButton
                                    id=""
                                    className="btn-default"
                                    tooltip={t(
                                        'TextLibrarySnippetTextLibrariesTable.edittextlibrary'
                                    )}
                                    onClick={() =>
                                        this.handleEditClicked(textlibrary)
                                    }
                                >
                                    <em className="fas fa-pencil-alt" />
                                </TooltipButton>
                                {this.props.userIsAuthorized(this.props.user, [
                                    'staff_super_admin',
                                    'staff_admin',
                                    'organisation_admin',
                                    'organisation_user'
                                ]) ? (
                                    <TooltipButton
                                        id="deleteButton"
                                        className="btn-danger pull-right"
                                        tooltip={t(
                                            'TextLibrarySnippetTextLibrariesTable.deletetextlibrary'
                                        )}
                                        onClick={() =>
                                            this.handleDeleteClicked(
                                                textlibrary
                                            )
                                        }
                                    >
                                        <em className="fa fa-trash" />
                                    </TooltipButton>
                                ) : null}
                            </td>
                        </tr>
                    )}
                </Draggable>
            );
        });

        return (
            <div
                id="TextLibrarySnippetTextLibrariesTable"
                className="TextLibrarySnippetTextLibrariesTable"
            >
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />

                <DragDropContext
                    onBeforeDragStart={this.onBeforeDragStart}
                    onDragEnd={this.onDragEnd}
                >
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                            <table
                                style={getListStyle(snapshot.isDraggingOver)}
                                ref={provided.innerRef}
                                className="table table-striped"
                            >
                                <thead>
                                    <tr>
                                        <th width="10"> </th>

                                        <th width="500">
                                            {t(
                                                'TextLibrarySnippetTextLibrariesTable.name'
                                            )}
                                        </th>

                                        <th className="hidden-xs">
                                            {t(
                                                'TextLibrarySnippetTextLibrariesTable.updated'
                                            )}
                                        </th>
                                        <th className="hidden-xs">
                                            {t(
                                                'TextLibrarySnippetTextLibrariesTable.created'
                                            )}
                                        </th>
                                        <th>
                                            <em className="fa fa-cog" />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>{textlibraryRows}</tbody>
                            </table>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
        );
    }
}

export default translate('translations')(TextLibrarySnippetTextLibrariesTable);
